var _path, _path2, _path3, _path4, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 204,
    height: 213,
    viewBox: "0 0 204 213",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.853 80.9326L200.853 110.22V118.516C200.853 122.867 205.836 204.734 200.853 204.734L101.644 124.901L2.24315 207.156C-2.73698 207.156 2.12987 127.711 2.12987 123.359L2.24315 110.22L2.2435 81.0198L16.301 69.2785L56.1626 35.9821L96.0242 2.68574C99.3124 0.397724 103.975 0.397724 107.264 2.68574L186.913 69.2785L200.853 80.9326Z",
    fill: "#214278"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.04 80.7529V170.318H39.6113V54.8926H136.016L163.04 80.7529Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.04 80.753V83.7729H132.892V54.7791L136.016 54.8927L163.04 80.753Z",
    fill: "#214278"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.04 80.7529H136.016V54.8926L163.04 80.7529Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_6337_255871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.5374 97.3528L102.13 141.99V212.329H9.41551C5.24171 212.329 0.395508 206.187 0.395508 206.187V84.9035C0.395508 81.6247 3.78211 78.9668 7.95591 78.9668C25.7335 78.9668 42.6692 85.6512 54.5374 97.3528Z",
    fill: "#214278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.748 97.4346L102.13 141.99V212.329L193.071 212.332C197.245 212.332 202.89 203.766 202.89 203.766V84.9853C202.89 81.7065 199.503 79.0486 195.329 79.0486C177.552 79.0486 160.616 85.733 148.748 97.4346Z",
    fill: "#214278"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_6337_255871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.892 179.697V205.381C202.892 209.22 198.852 212.332 193.872 212.332H9.41551C4.43538 212.332 0.395508 209.22 0.395508 205.381V179.697L96.0239 121.01C97.5792 120.056 99.4433 119.551 101.327 119.498C103.418 119.44 105.53 119.948 107.266 121.01L202.892 179.697Z",
    fill: "#3266BB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_6337_255871",
    x: -27.6045,
    y: 50.9668,
    width: 258.494,
    height: 189.365,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_6337_255871"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_6337_255871",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_6337_255871",
    x: -9.60449,
    y: 109.494,
    width: 222.496,
    height: 112.838,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_6337_255871"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_6337_255871",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLetter);
export default __webpack_public_path__ + "static/media/email-letter.f0769c1e2093d06c7296ec22561c8559.svg";
export { ForwardRef as ReactComponent };